import clsx from "clsx";
import './popup.scss';

const Popup = ({className, show, content}) => {
    return (
        <div className={clsx('avo__popup', className, show ? 'show' : 'hide')}>
            {content}
        </div>
    )
}

export default Popup
